import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'components/common/types/Store.types';
import { getIsReseller } from 'store/publisher/selectors';
import { CampaignType } from 'components/pages/Planner/PlannerSections/types';
import { DealStatus } from 'components/common/types/Deal.types';
import { getHasProgrammaticCampaignRequiredFields } from './getHasProgrammaticCampaignRequiredFields';
import { getAreResellerLinesValid, getAreProgrammaticLinesValid } from './getAreProgrammaticLinesValid';

export const getIsProgrammaticDraftCampaignTransitionEnabled = createSelector(
  [
    (state: Store) => state.dealManagement.campaignType,
    (state: Store) => state.dealManagement.commonDeal.bookingStatusCode,
    getHasProgrammaticCampaignRequiredFields,
    getIsReseller,
    getAreResellerLinesValid,
    getAreProgrammaticLinesValid,
  ],
  (
    campaignType,
    bookingStatusCode,
    hasRequiredCampaignFields,
    isReseller,
    areAllResellerLinesValid,
    areAllNonResellerLinesValid,
  ) => {
    if (campaignType !== CampaignType.PROGRAMMATIC) return false;
    if (bookingStatusCode !== DealStatus.DRAFT) return false;
    if (!hasRequiredCampaignFields) return false;

    return isReseller ? areAllResellerLinesValid : areAllNonResellerLinesValid;
  },
);
